<template>
  <div class="labeled-value">
    <div class="labeled-value__label">
      <span class="bhGray2--text">{{ label }}</span>
    </div>
    <div class="labeled-value__value">
      <slot>
        <strong class="bhBlack--text">{{ value }}</strong>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LabeledValue',
  components: {},
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({}),
  mounted() {},
  computed: {},
  methods: {},
}
</script>
<style lang="scss">
.labeled-value {
}
</style>
